<script>
import { NodeMixin } from '@/helpers/node-mixin';

export default {
  name: 'ActionNode',
  template: '#action-node-template',
  mixins: [NodeMixin],
  setup(props) {
  },
  emits: ['click'],
};
</script>
